<!-- 取消零坦下发弹窗 -->
<template>
    <performance-common-dialog
        :title="'零坦下发弹窗'"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'700PX'"
        class="dispatch-issue-modal"
    >
        <template #top>
            <el-form ref="formRef" label-position="right" label-width="100px">
                <el-form-item label="发车单号：">
                    <span>{{ componentsData.dispatchNo }}</span>
                </el-form-item>
            </el-form>
        </template>
        <template #table-list>
            <div>
                <table-box
                    ref="tablePage"
                    :selection="true"
                    :columns="config.table.columns"
                    :height="config.table.height"
                    :rows="tableData"
                    @selection-change="handleSelectionChange"
                >
                </table-box>
                <div class="dispatch-table-button">
                    <el-button
                        type="primary"
                        @click="handleSure"
                        :loading="sureLoading"
                        :disabled="!selected.length"
                    >
                        确定
                    </el-button>
                </div>
            </div>
        </template>
    </performance-common-dialog>
</template>

<script>
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';
import tableBox from '@/components/lots/tableBox/Index.vue';
import { pageCreateOnlineOdersANNTO } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import config from './config.js';

export default {
    components: {
        PerformanceCommonDialog,
        tableBox
    },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {
                    dispatchNo: '',
                    tableData: []
                };
            }
        }
    },
    data () {
        return {
            config,
            selected: [], // 选中数据
            tableData: [],
            sureLoading: false,
            pageTotal: 0,
            currentPage: 1
        };
    },
    mounted () {
        this.$refs.performanceCommonDialog.show();
        this.$nextTick(() => {
            this.tableData = this.componentsData.tableData;
        });
    },
    methods: {
        /**
         * @description 确认下发
        */
        handleSure () {
            if (this.selected.length > 1) {
                return this.$message.warning('只能选择一条数据进行操作！');
            }
            this.sureLoading = true;
            const params = {
                dispatchNo: this.componentsData.dispatchNo,
                ...this.selected[0]
            };
            pageCreateOnlineOdersANNTO(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('下发零担成功');
                    this.dialogClose();
                }
            }).finally(() => {
                this.sureLoading = false;
            });
        },
        /**
         * @description 复选框勾选
         * @param {Array} rows 勾选的数据
        */
        handleSelectionChange (rows) {
            this.selected = rows;
        },
        // 关闭弹窗
        dialogClose () {
            this.$emit('components-close');
        }
    }
};
</script>

<style lang='less'>
.dispatch-table-button {
    margin-top: 10px;
    text-align: right;
}
</style>
